import { getHours, getMinutes, isToday, isAfter, isTomorrow } from "date-fns";

class DateVerifySnack {
  AvailableTwoHours(
    orderHours,
    orderMinutes,
    nowHours,
    nowMinutes,
    dayOrder,
    now
  ) {
    if (isToday(dayOrder)) {
      if (orderHours > nowHours && orderHours - nowHours > 2) return true;

      if (orderHours - nowHours == 2) {
        if (orderMinutes == 0) return true;
        if (orderMinutes >= nowMinutes) return true;
      }
      return false;
    }
    return true;
  }

  AvailableOneDay(dayOrder, now, time) {
    var nowHours = getHours(now);
    var nowMinutes = getMinutes(now);

    if (isAfter(dayOrder, now)) {
      if (isTomorrow(dayOrder)) {
        if (time[0] > nowHours) {
          return true;
        } else if (time[0] == nowHours) {
          if (time[1] >= nowMinutes) return true;
        }
        return false;
      }
      return true;
    }
    return false;
  }

  handleVerify(now, dayOrder, time, type_service) {
    var values = time.split(":");
    if (type_service === "snack" || type_service === "soda") {
      //Lanche com 2h de antecedência
      if (
        !this.AvailableTwoHours(
          values[0],
          values[1],
          getHours(now),
          getMinutes(now),
          dayOrder,
          now
        )
      ) {
        return {
          error: true,
          type: "availableTwoHours",
          message: "Você não pode solicitar este lanche sem 2h de antecedência",
        };
      }
      return { error: false };
    }

    //Coffe com 24h de antecedência
    if (!this.AvailableOneDay(dayOrder, now, values)) {
      return {
        error: true,
        type: "availableOneDay",
        message: "Você não pode solicitar este coffee sem 24h de antecedência",
      };
    }

    return false;
  }
}

export default new DateVerifySnack();
